module.exports = __webpack_public_path__ + "img/logo.51cecca9.svg";